import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Select.scss';

const Select = ({ variantClasses = [], id, options, selected, inputChange, label = null, isError = false, inputBlur = () => {}, disabledKey = 'disabled', ...props }) => {
	const inputChangeHandler = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputChange($input.id, $input.value);
	};

	const inputBlurHandler = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputBlur($input.id, $input.value);
	};

	const selectClasses = [s.select, s[`select__${id}`]];
	const labelClasses = [s.label];

	if (!Array.isArray(variantClasses)) variantClasses = [String(variantClasses)];
	variantClasses.filter((c) => !!c).forEach((c) => {
		if (c.indexOf('label') !== -1) labelClasses.push(s[c]);
		else selectClasses.push(s[c]);
	});

	if (isError !== false) {
		selectClasses.push(s.select__error);
		labelClasses.push(s.label__error);
	}

	const select = (
		<div className={selectClasses.join(' ')}>
			<select name={id} id={id} onChange={inputChangeHandler} onBlur={inputBlurHandler} value={selected} {...props}>
				{
					options.map((option) => (typeof option === 'object' ? <option key={option.key} value={option.key} disabled={option[disabledKey] ? true : null}>{option.value}</option> : <option key={option} value={option}>{option}</option>))
				}
			</select><svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8"><polyline points="1167 1513 1173 1519 1179 1513" transform="translate(-1166 -1512)" /></svg>
		</div>
	);

	if (label) {
		return (
			<label className={labelClasses.join(' ')} htmlFor={id}>
				<span className={s.label_title}>{ label }</span>
				{ select }
			</label>
		);
	}

	return select;
};

export default hot(module)(Select);
